import React from 'react'

import LoadingIndicator from '../components/LoadingIndicator'

class WithRecharts extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      recharts: null
    }
  }

  UNSAFE_componentWillMount() {
    import(/* webpackChunkName: "recharts" */ 'recharts').then(exports => {
      this.setState({ recharts: exports })
    })
  }

  render() {
    const { recharts } = this.state
    const {
      component: Component,
      loadingComponent: LoadingComponent,
      ...rest
    } = this.props

    if (recharts) {
      const passedProps = { ...rest, recharts }

      return <Component {...passedProps} />
    }

    return (
      <LoadingComponent newSiteLook={dynamicValues.newSiteLook} unContained={false} />
    )
  }
}

export default (component, loadingComponent = LoadingIndicator) => {
  return props => (
    <WithRecharts {...props} component={component} loadingComponent={loadingComponent} />
  )
}
